import React, { createContext, useContext, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const ToastMessage = styled.div(props => css`
  position: fixed;
  bottom: 64px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 16px;
  border-radius: 4px;
  width: 96%;
  text-align: center;
  z-index: 1000;
  font-family: ${props?.fontFamily};
  animation: ${fadeIn} 0.5s, ${fadeOut} 1s 3s forwards;
`);

// Create Context
const ToastContext = createContext((message : string, fontFamily : string = 'inherit') => {});

// Toast Provider
export const ToastProvider = ({ children }) => {
  const [message, setMessage] = useState<string | null>(null);
  const [fontFamily, setFontFamily] = useState<string>('inherit');

  const addToast = (message, fontFamily = 'inherit') => {
    setMessage(message);
    setFontFamily(fontFamily);
    setTimeout(() => setMessage(null), 3000); // auto-hide after 3 seconds
  };

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      {message && 
        <ToastMessage fontFamily={fontFamily}>
          {message}
        </ToastMessage>}
    </ToastContext.Provider>
  );
};

// Hook to use Toast
export const useToast = () => {
  const addToast = useContext(ToastContext);
  return addToast;
};